import isEmpty from 'lodash/isEmpty';

import { TFunction } from '@lyearn/i18n';
import { Fields, FieldType } from '@/components/Form';
import { PropertiesToDuplicateEnum } from '@/types/schema';

import { getPropertiesToDuplicateOptions } from '../../utils';
import PropertiesToDuplicateSelector from '../PropertiesToDuplicateSelector';
import TaskLocationSelector from '../TaskLocationSelector';

export type DuplicateTaskEditorFormValues = {
  title: string;
  duplicateFromId: string;
  propertiesToDuplicate: PropertiesToDuplicateEnum[];
  fileId: string | null;
};

export const getInitialValues = ({
  t,
  duplicateFromId,
  title,
}: {
  t: TFunction;
  duplicateFromId?: string;
  title?: string;
}): DuplicateTaskEditorFormValues => {
  return {
    duplicateFromId: duplicateFromId || '',
    title: title ? title + t('Task:DuplicationProperties.Copy') : t('Task:DuplicateTask.Title'),
    propertiesToDuplicate: getPropertiesToDuplicateOptions(t).map((option) => option.value),
    fileId: null,
  };
};

export const getFormFields = (t: TFunction): Fields<DuplicateTaskEditorFormValues> => {
  return {
    title: {
      name: 'title',
      label: t('Task:DuplicateTask.NewTaskName'),
      type: FieldType.Text,
      size: 'large',
      required: true,
    },
    fileId: {
      name: 'fileId',
      required: false,
      type: FieldType.SlowCustom,
      Component: ({ value, onChange }) => {
        return <TaskLocationSelector value={value} onChange={onChange} />;
      },
    },
    propertiesToDuplicate: {
      name: 'propertiesToDuplicate',
      required: true,
      type: FieldType.Custom,
      label: t('Task:DuplicationProperties.PropertiesToDuplicateLabel'),
      Component: ({ value, onChange }) => {
        return <PropertiesToDuplicateSelector value={value} onChange={onChange} />;
      },
    },
  };
};

export const FORM_LAYOUT = ['title', 'fileId', 'propertiesToDuplicate'];

export const validateForm = (t: TFunction) => (values: any) => {
  const errors: any = {};

  if (isEmpty(values.title)) {
    errors.title = t('Task:DuplicateTask.TaskNameCannotBeEmpty');
  }

  return errors;
};
